module.exports = __webpack_public_path__ + "img/11.3fb6ae7e.png";